import { ILeadFilter } from '@zet/utils/interface'
import { create } from 'zustand'

const useLeadFilterStore = create<ILeadFilter>((set) => ({
  leadFilters: {},
  updateFilter: (payload) =>
    set((state) => ({
      leadFilters: {
        ...state.leadFilters,
        ...payload,
      },
    })),
  resetLeadFilters: () => set(() => ({ leadFilters: {} })),
}))

export default useLeadFilterStore
